import { render, staticRenderFns } from "./SpecialProducts.vue?vue&type=template&id=260de1d2&scoped=true&"
import script from "./SpecialProducts.vue?vue&type=script&lang=js&"
export * from "./SpecialProducts.vue?vue&type=script&lang=js&"
import style0 from "./SpecialProducts.vue?vue&type=style&index=0&id=260de1d2&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "260de1d2",
  null
  
)

export default component.exports